export const STATUS_IDLE = 'idle';
export const STATUS_CHECKING_COMPATIBILITY = 'checking_compatibility';
export const STATUS_COMPATIBLE = 'compatible';
export const STATUS_INCOMPATIBLE = 'incompatible';
export const STATUS_INSTALLATION_STARTED = 'installation_started';
export const STATUS_INSTALLATION_IN_PROGRESS = 'installation_in_progress';
export const STATUS_INSTALLATION_COMPLETE = 'installation_complete';
export const STATUS_INSTALLATION_FAILED = 'installation_failed';

export const ACTION_OPEN_UPDATE_MODAL = 'firmware/OPEN_UPDATE_MODAL';
export const ACTION_CLOSE_UPDATE_MODAL = 'firmware/CLOSE_UPDATE_MODAL';
export const ACTION_SET_AVAILABLE_VERSIONS = 'firmware/SET_AVAILABLE_VERSIONS';
export const ACTION_SELECT_VERSION = 'firmware/SELECT_VERSION';
export const ACTION_START_COMPATIBILITY_CHECK = 'firmware/START_COMPATIBILITY_CHECK';
export const ACTION_SET_UPDATE_STATUS = 'firmware/SET_UPDATE_STATUS';
export const ACTION_SET_FORCE_UPDATE = 'firmware/SET_FORCE_UPDATE';
export const ACTION_START_INSTALLATION = 'firmware/START_INSTALLATION';
export const ACTION_UPDATE_INSTALLATION_PROGRESS = 'firmware/UPDATE_INSTALLATION_PROGRESS';
